import { makeAutoObservable, runInAction } from 'mobx'
import { tours } from './tourSteps'

class TourStore {
  run = false
  stepIndex = 0
  steps = []
  // Флаг для принудительного показа тура в режиме отладки. Управляется через .env файл.
  forceShowTour = process.env.REACT_APP_FORCE_SHOW_TOUR === 'true'
  router = null

  constructor(rootStore) {
    makeAutoObservable(this, { rootStore: false }, { autoBind: true })
    this.rootStore = rootStore
    this.errorStore = rootStore.errorStore
  }

  /**
   * Загружает шаги для конкретного тура и запускает его.
   * @param {string} tourKey - Ключ тура из объекта tours (например, 'main' или 'calendar').
   */
  loadAndStartTour(tourKey) {
    if (tours[tourKey]) {
      this.steps = tours[tourKey]
      this.startTour()
    } else {
      console.error(`Тур с ключом "${tourKey}" не найден.`)
    }
  }

  setForceShow(force) {
    this.forceShowTour = !!force
    console.log(
      `Принудительный показ тура ${this.forceShowTour ? 'включен' : 'отключен'}.`,
    )
  }

  /**
   * Запускает тур.
   */
  startTour() {
    this.run = true // Убедимся, что тур запускается, даже если он уже был запущен
    this.stepIndex = 0
  }

  /**
   * Останавливает тур.
   */
  stopTour() {
    this.run = false
    this.stepIndex = 0
    this.steps = [] // Очищаем шаги после остановки
  }

  /**
   * Обрабатывает колбэки от react-joyride для управления состоянием.
   * @param {import('react-joyride').CallBackProps} data
   */
  handleJoyrideCallback(data) {
    const { action, index, status, type, step } = data

    if (['finished', 'skipped'].includes(status)) {
      // Тур завершен или пропущен пользователем
      // Отключаем автоматический показ тура при следующем входе.
      this.rootStore.userStore.updateUserSettings({
        showTourOnLogin: false,
      })
      this.stopTour()
    } else if (action === 'close') {
      // Пользователь нажал на крестик
      this.stopTour()
    } else if (['next', 'prev'].includes(action) && type === 'step:after') {
      // Обновляем индекс текущего шага
      runInAction(() => {
        this.stepIndex = index + (action === 'next' ? 1 : -1)
      })

      // Проверяем, есть ли у следующего шага указание на смену роута
      const nextStep = this.steps[this.stepIndex]
      if (nextStep?.route && this.router) {
        this.router.push(nextStep.route)
      }
    } else if (type === 'error:target_not_found') {
      console.error(`Цель для шага ${index} не найдена.`)
      // Если цель не найдена, можно либо остановить тур, либо пропустить шаг.
      // Остановка - более безопасный вариант.
      this.errorStore.showError(
        'Элемент для подсказки не найден. Тур будет остановлен.',
      )
      this.stopTour()
    } else if (action === 'reset') {
      // Перезапуск тура
      this.startTour()
    }

    console.log('Joyride callback', data)
  }
}

export default TourStore
